module.exports = __webpack_public_path__ + "img/telephoneOf.43aeb56a.svg";